// Support / help contacts shown in the UI ("Need help?", "Contact Support",
// deactivated-account modals, Help section, OffSec request help).
//
// Set per environment in cara_frontend/.env (local/dev and prod use
// different values). CRA bakes REACT_APP_* in at build/start time, so
// restart `npm start` or rebuild after changing them. The defaults below are
// the values that were hardcoded before, so an unset variable changes nothing.

// Login pages, OTP pages and deactivated-account modals.
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'cara.tech@cyberinsurify.com';

// Help section and the session-expired / session-conflict dialog.
export const HELPDESK_EMAIL = process.env.REACT_APP_HELPDESK_EMAIL || 'support@CARAgrc.com';

// OffSec "New Service Request" help text.
export const OFFSEC_REQUESTS_EMAIL = process.env.REACT_APP_OFFSEC_REQUESTS_EMAIL || 'offsecrequests@caragrc.com';
